<section>
  <opac-text-input [formControl]="identifierFormControl"> {{ 'user.fields.id' | translate }} </opac-text-input>
  <opac-password-input [formControl]="passwordFormControl">
    {{ 'user.fields.password' | translate }}</opac-password-input
  >

  <opac-button type="primary" (click)="login()">{{ 'login.submit' | translate }}</opac-button>
</section>
